import React from 'react';
import MediumWidthContainer from '../Layout/Containers/MediumWidthContainer';
import PageHeaderComponent from '../util/PageHeader/PageHeaderComponent';
import ProfileComponent from '../util/Profile/ProfileComponent';
import styles from './ourTeam.module.scss';

const OurTeamComponent = () => {
    return (
        <section>
            <PageHeaderComponent
                quote="The management team, board members and directors at Noria have an extensive experience in IT Solutions and Services for banking and insurance, customer service, product development, marketing, and management.
                    <br/><br/>For inquiries, please reach out to us. We would love to hear from you."
            >
                <h1>Management</h1>
            </PageHeaderComponent>
            <MediumWidthContainer extraClassNames={styles.profilesContainer}>
                <ProfileComponent
                    name="Ronny Reppe"
                    role="CEO in Noria Software and Member of the boards"
                    linkedInProfile="https://www.linkedin.com/in/ronnyreppe/"
                    image={{
                        src: '/images/ronny-reppe.jpg',
                        alt: 'Ronny Reppe - CEO in Noria Software and Member of the boards',
                        maxWidth: 460,
                        maxHeight: 595,
                    }}
                />

                <ProfileComponent
                    name="Hilda Beate Lygre"
                    role="CEO in Noria Vest"
                    linkedInProfile="https://www.linkedin.com/in/hilda-beate-lygre-51031726/"
                    image={{
                        src: '/images/hildabeate.webp',
                        alt: 'Hilda Beate Lygre - CEO in Noria Vest',
                        maxWidth: 460,
                        maxHeight: 595,
                    }}
                />

                <ProfileComponent
                    name="Hugo Sundkjaer"
                    role="CEO in Noria Consulting"
                    linkedInProfile="https://www.linkedin.com/in/hugo-sundkjer/"
                    image={{
                        src: '/images/hugo.png',
                        alt: 'Hugo Sundkjaer - CEO in Noria Consulting',
                        maxWidth: 460,
                        maxHeight: 595,
                    }}
                />
            </MediumWidthContainer>
        </section>
    );
};

export default OurTeamComponent;
